import { render } from "./AdminPedidos.vue?vue&type=template&id=1fd2edab"
import script from "./AdminPedidos.vue?vue&type=script&lang=js"
export * from "./AdminPedidos.vue?vue&type=script&lang=js"

import "./AdminPedidos.vue?vue&type=style&index=0&id=1fd2edab&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__